import {
  InlineNotification,
  NotificationType,
} from '@spotted-zebra-uk/ui-components';
import styles from './password-notification.module.scss';
import { useTranslation } from 'react-i18next';

export function PasswordNotification() {
  const { t } = useTranslation();

  return (
    <InlineNotification
      notificationType={NotificationType.NEUTRAL}
      className={styles.notification}
      data-testid="password-notification"
    >
      <div className={styles.notificationBody}>
        {t('setNewPassword.passwordMustContain')}
      </div>
    </InlineNotification>
  );
}
